
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface RecomputeFreelancerQualityRequest {
    profileId: string;
}

/**
 * 
 */
export class SearchJobApi extends runtime.BaseAPI {

    /**
     * Manual trigger for the freelancer quality job
          */
    async recomputeAllFreelancerQualityRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/admin/job/freelancer-quality`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Manual trigger for the freelancer quality job
          */
    async recomputeAllFreelancerQuality(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.recomputeAllFreelancerQualityRaw(initOverrides);
    }

    /**
     * Manual trigger for the freelancer quality job for a single freelancer
          */
    async recomputeFreelancerQualityRaw(requestParameters: RecomputeFreelancerQualityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling recomputeFreelancerQuality().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/admin/job/freelancer-quality/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Manual trigger for the freelancer quality job for a single freelancer
          */
    async recomputeFreelancerQuality(requestParameters: RecomputeFreelancerQualityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.recomputeFreelancerQualityRaw(requestParameters, initOverrides);
    }

}
